<template>
  <div class="search-events">
    <search-events-form
      @receive-data="setEventsData"
      @reset-data="handleReset"
      :skip="skip"
      :limit="limit"
      :all="all"
    />

    <event-preview-list
      :events="eventArray"
      :total="total"
      :with-card="true"
      :limit="limit"
      :current-page="currentPage"
      :on-navigate="onNavigate"
    />
  </div>
</template>

<script>
import EventPreviewList from '@/components/events/EventPreviewList.vue';
import SearchEventsForm from '@/components/events/SearchEventsForm.vue';

export default {
  name: 'SearchEvents',
  components: {
    EventPreviewList,
    SearchEventsForm,
  },
  data() {
    return {
      eventArray: [],
      total: null,
      limit: 20,
      currentPage: 1,
      eventToJoin: null,
    };
  },
  props: {
    all: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    skip() {
      const { currentPage, limit } = this;
      return (currentPage - 1) * limit;
    },
  },
  methods: {
    setEventsData(data) {
      this.eventArray = data.items;
      this.total = data.totalCount;
    },
    onNavigate(nextPage) {
      this.currentPage = nextPage;
    },
    handleReset() {
      this.eventArray = [];
      this.total = null;
    },
  },
};
</script>

<style lang="scss">

</style>
